export default __webpack_public_path__ + "static/media/lock.bc112ffa.svg";